
<span class="container__info">
  <mat-icon>info</mat-icon>
  Source: Johns Hopkins University, Center for Systems Science and Engineering (CSSE).
</span>
<div id="rpd-covid19-map"
  class="rpd-covid19">
</div>

